import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "all";
  const [products, setProducts] = useState([]);
  const [cats, setCats] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/products/categories").then((r) => setCats(r.data)).catch(() => {}); }, []);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: { category, search: search || undefined } })
      .then((r) => setProducts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [category, search]);

  const setCategory = (c) => { const p = new URLSearchParams(params); if (c === "all") p.delete("category"); else p.set("category", c); setParams(p); };

  return (
    <div className="max-w-[1600px] mx-auto px-5 sm:px-8 py-16 sm:py-20 min-h-[70vh]">
      <div className="mb-12">
        <p className="label-caps text-muted-foreground mb-3">The Collection</p>
        <h1 className="font-serif-display text-5xl sm:text-6xl font-light tracking-tighter">{category === "all" ? "All pieces" : category}</h1>
      </div>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 mb-12 border-b border-line pb-6">
        <div className="flex flex-wrap gap-x-7 gap-y-2">
          {["all", ...cats].map((c) => (
            <button key={c} onClick={() => setCategory(c)} data-testid={`filter-${c.toLowerCase()}`}
              className={`label-caps transition-colors ${category === c ? "text-ink underline underline-offset-8" : "text-muted-foreground hover:text-ink"}`}>
              {c === "all" ? "All" : c}
            </button>
          ))}
        </div>
        <div className="relative w-full md:w-64">
          <Search strokeWidth={1.5} className="absolute left-0 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search" data-testid="search-input"
            className="w-full bg-transparent border-b border-line pl-6 py-2 text-base focus:outline-none focus:border-ink transition-colors" />
        </div>
      </div>

      {loading ? (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {[...Array(8)].map((_, i) => <div key={i} className="aspect-[4/5] bg-surface animate-pulse" />)}
        </div>
      ) : products.length === 0 ? (
        <p className="font-serif-display text-2xl text-muted-foreground py-20 text-center" data-testid="no-products">No pieces found.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8" data-testid="product-grid">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
